import React from 'react';
import {InvoiceTransactionVO} from "../../../types/model/valueObject/invoice/InvoiceTransactionVO";
import {BuyerInvoicesCardListItem} from "./BuyerInvoicesCardListItem";
import {withLoader} from "../../hocs/withLoader";
import {LocationCardSkeleton} from "../../common/reports/loadingSkeletons/LocationCardSkeleton";

export interface BuyerInvoicesCardListProps {
  items?: InvoiceTransactionVO[];
  expandByIndex: Array<boolean>;
  onToggleExpand: (index: number) => void;
}

const BuyerInvoicesCardList = ({
  items,
  expandByIndex,
  onToggleExpand,
}: BuyerInvoicesCardListProps) => {
  if (!items?.length) {
    return null;
  }

  return <>
    {
      items.map((item, index) =>
        <BuyerInvoicesCardListItem
          key={item.transactionId}
          item={item}
          expanded={expandByIndex[index]}
          onToggleExpand={() => onToggleExpand(index)}
        />
      )
    }
  </>
}

const skeletonLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <LocationCardSkeleton key={index} />
));

const BuyerInvoicesCardListWithLoader = withLoader(BuyerInvoicesCardList, skeletonLoader);

export {
  BuyerInvoicesCardList,
  BuyerInvoicesCardListWithLoader
};
